var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Layers component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLayers extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.5733 2.6934L2.7023 6.83318C2.68423 6.84348 2.669 6.85817 2.65806 6.87594C2.64602 6.89549 2.63965 6.918 2.63965 6.94096C2.63965 6.96392 2.64602 6.98643 2.65806 7.00598C2.66889 7.02359 2.68394 7.03817 2.70178 7.04845L11.5724 11.1569C11.7076 11.2145 11.853 11.2442 12 11.2442C12.1467 11.2442 12.2918 11.2146 12.4268 11.1573L21.2977 7.01753C21.3158 7.00724 21.331 6.99254 21.342 6.97477C21.354 6.95522 21.3604 6.93271 21.3604 6.90975C21.3604 6.88679 21.354 6.86428 21.342 6.84473C21.3311 6.82712 21.3161 6.81254 21.2982 6.80226L12.4276 2.69377C12.2924 2.63622 12.147 2.60654 12 2.60654C11.8533 2.60654 11.7082 2.63609 11.5733 2.6934ZM10.9677 1.32099C11.2935 1.17953 11.6449 1.10654 12 1.10654C12.3552 1.10654 12.7065 1.17953 13.0323 1.32099L13.0488 1.32838L21.9452 5.44881C21.9527 5.45232 21.9603 5.45596 21.9677 5.45972C22.2361 5.59511 22.4617 5.80235 22.6193 6.05836C22.7769 6.31437 22.8604 6.60911 22.8604 6.90975C22.8604 7.21038 22.7769 7.50512 22.6193 7.76113C22.4617 8.01715 22.2361 8.22439 21.9677 8.35977C21.9609 8.36321 21.954 8.36654 21.9471 8.36977L13.0507 12.5214L13.0323 12.5297C12.7065 12.6712 12.3552 12.7442 12 12.7442C11.6449 12.7442 11.2935 12.6712 10.9677 12.5297L10.9513 12.5223L2.05487 8.4019C2.04729 8.39839 2.03977 8.39475 2.03231 8.39099C1.76389 8.2556 1.53831 8.04836 1.3807 7.79235C1.2231 7.53634 1.13965 7.2416 1.13965 6.94096C1.13965 6.64033 1.2231 6.34559 1.3807 6.08958C1.53831 5.83356 1.76389 5.62632 2.03231 5.49094C2.03913 5.4875 2.04599 5.48417 2.0529 5.48094L10.9493 1.3293L10.9677 1.32099Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.8259 12.2304C22.9992 12.6066 22.8347 13.052 22.4585 13.2254L12.9378 17.6111L12.9352 17.6123C12.6342 17.7496 12.3072 17.8207 11.9763 17.8207C11.6454 17.8207 11.3183 17.7496 11.0173 17.6123L11.0135 17.6105L11.0135 17.6105L1.5396 13.2248C1.16371 13.0508 1.00005 12.605 1.17406 12.2291C1.34808 11.8532 1.79386 11.6895 2.16975 11.8635L11.6398 16.2476C11.6403 16.2478 11.6409 16.248 11.6414 16.2483C11.7466 16.296 11.8607 16.3207 11.9763 16.3207C12.092 16.3207 12.2063 16.2959 12.3117 16.248C12.312 16.2479 12.3124 16.2477 12.3127 16.2476L21.8309 11.863C22.2071 11.6897 22.6526 11.8541 22.8259 12.2304Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.8259 17.3026C22.9992 17.6788 22.8347 18.1243 22.4585 18.2976L12.9378 22.6834L12.9352 22.6845C12.6342 22.8219 12.3072 22.8929 11.9763 22.8929C11.6454 22.8929 11.3183 22.8219 11.0173 22.6845L11.0135 22.6828L11.0135 22.6828L1.5396 18.297C1.16371 18.123 1.00005 17.6772 1.17406 17.3013C1.34808 16.9255 1.79386 16.7618 2.16975 16.9358L11.6398 21.3198C11.6403 21.3201 11.6409 21.3203 11.6414 21.3205C11.7466 21.3682 11.8607 21.3929 11.9763 21.3929C12.092 21.3929 12.2063 21.3682 12.3117 21.3203C12.312 21.3201 12.3124 21.32 12.3127 21.3198L21.8309 16.9352C22.2071 16.7619 22.6526 16.9264 22.8259 17.3026Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLayers.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLayers.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLayers.prototype, "size", void 0);
if (customElements.get('cat-icon-layers') === undefined) {
    customElements.define('cat-icon-layers', BlocksIconLayers);
}
